<template>
  <div class="orderdone">
    <div class="container">
      <!-- Content here -->
      <br />

      <nav class="navbar navbar-expand-lg navbar-light bg-light">
        <a class="navbar-brand" href="#">我們收到委託單了</a>
      </nav>

      <br />
      <div class="card">
        <div class="card-body">
          <h5>我們確認收到委託單了!</h5>
          <br />
          <h5>我們可以回到聊天室繼續操作了!</h5>

          <!-- <router-link to="/store">
            <button type="button" class="btn btn-primary btn-block">
              回到商品列
            </button>
          </router-link>-->
        </div>
      </div>
      <br />
      <div class="card">
        <div class="card-body">
          <p>你可能也會想批這些:</p>
          <div
            v-for="(recommends_info, recommends_index) in recommends"
            v-bind:key="(recommends_info, recommends_index)"
            style="display: inline-block; padding: 5px"
          >
            <b-badge
              v-bind:href="recommends_info.recommend_url"
              variant="info"
              target="_blank"
              @click="gaClickEvents(recommends_info)"
              >{{ recommends_info.recommend_key }}</b-badge
            >
          </div>
        </div>
      </div>
    </div>
    <div class="promotion" @click="goPromotionUrl(images[random].url)">
      <img
        class="promotion-image"
        v-bind:src="images[random].image"
        @click="goPromotionUrl(images[random].url)"
      />
    </div>
    <loading
      loader="bars"
      :active.sync="isLoading"
      :can-cancel="true"
      :is-full-page="true"
    ></loading>
  </div>
</template>
<style type="text/css">
.promotion {
  width: 100%;
  overflow: hidden;
  position: fixed !important;
  bottom: 0px;
  cursor: pointer;
  margin: 0 auto;
  text-align: center;
}
.promotion-image {
  width: 90%;
  max-width: 800px;
}
</style>
<script>
import VueLoading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  name: 'orderdone',
  components: {
    loading: VueLoading,
  },
  data: function () {
    return {
      apiUrl: '',
      isLoading: false,
      userId: '',
      userImage: '',
      userName: '',
      recommends: [],
      random: 0,
      images: [
        {
          title: '1',
          image: 'https://i.imgur.com/4K9vU5c.jpeg',
          url: 'https://chatxbuy.pse.is/79v9sr',
        },
      ],
    }
  },
  watch: {},
  methods: {
    clearShoppingCart: function () {
      const vm = this
      vm.$store.prodInfos = []
      localStorage.setItem('prodInfos', JSON.stringify([]))
      vm.$forceUpdate()
    },
    getRecommends: function () {
      const vm = this
      vm.recommends = JSON.parse(localStorage.getItem('recommendInfo')).concat()
    },
    gaClickEvents: function (recommendsInfo) {
      const vm = this
      vm.$ga.event(
        'useFeatures',
        'clickButton',
        recommendsInfo.recommend_key,
        1
      )
    },
    goPromotionUrl: function (promoteUrl) {
      window.open(promoteUrl)
    },
  },
  mounted() {
    const vm = this

    setInterval(function () {
      // if (vm.random == 0) {
      vm.random = Math.floor(Math.random() * vm.images.length)
      // }
    }, 1600)

    vm.$toast.open({
      message: '確認建立委託單中~ 請稍候3秒鐘...',
      type: 'success',
    })

    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0

    setTimeout(function () {
      vm.$toast.open({
        message: '確認推播完成！！',
        type: 'success',
      })
    }, 4000)

    // //Event snippet for 進入機器人收到委託單頁面 conversion page
    // vm.$ga.event("event", "conversion", {
    //   send_to: "AW-700538278/6PJGCM2_4rIBEKa7hc4C",
    //   value: 1.0,
    //   currency: "TWD",
    // });

    vm.clearShoppingCart()
    vm.getRecommends()
  },
}
</script>
